export const services = [
  {
    id: "outsourced-consultancy",
    title: "Retained Health & Safety Support",
    description:
      "Flexible, ongoing health and safety support acting as your dedicated external compliance partner.",
    keywords: [
      "Competent Person Support",
      "Retained Consultancy",
      "Interim Cover",
      "Strategic Guidance",
      "Policy Oversight",
      "Board-Level Advice",
    ],
    image: "/images/sections/servicesShowcase/sml-expert-advice-2.webp",
    imagePosition: "44% center",
    href: "/services/outsourced-consultancy",
  },
  {
    id: "health-safety-consultancy",
    title: "Health & Safety Consultancy",
    description:
      "Comprehensive support to help businesses manage risk, ensure compliance, and maintain safe working environments.",
    keywords: [
      "Audits",
      "Compliance Reviews",
      "Risk Assessments",
      "Policies & Systems",
      "Fire Risk",
      "Consultant Support",
    ],
    image: "/images/sections/servicesShowcase/sml-health-safety-2.webp",
    imagePosition: "58% center",
    href: "/services/health-safety",
  },
  {
    id: "statutory-inspections",
    title: "Statutory Inspection Management",
    description:
      "End-to-end management of required inspections to ensure all equipment and operations meet legal safety standards.",
    keywords: [
      "LOLER",
      "PSSR",
      "Engineering Inspections",
      "Written Schemes",
      "Compliance Tracking",
      "Provider Oversight",
    ],
    image: "/images/sections/servicesShowcase/sml-compliance-inspection-2.webp",
    imagePosition: "72% center",
    href: "/services/statutory-inspection-management",
  },
  {
    id: "occupational-hygiene",
    title: "Occupational Hygiene",
    description:
      "Expert assessment and control of workplace health hazards such as noise, dust, and exposure to harmful substances.",
    keywords: [
      "Air Monitoring",
      "LEV Testing",
      "COSHH",
      "Noise Surveys",
      "Exposure Control",
      "Workplace Health Risk",
    ],
    image: "/images/sections/servicesShowcase/sml-employees-2.webp",
    imagePosition: "64% center",
    href: "/services/occupational-hygiene-consultancy",
  },
  {
    id: "consultant-led-training",
    title: "Health & Safety Training",
    description:
      "Practical, expert-led training sessions designed to improve awareness, skills, and workplace safety culture.",
    keywords: [
      "Consultant-Led Courses",
      "Management Awareness",
      "On-Site Delivery",
      "Certificates",
      "Risk-Based Learning",
      "Refresher Planning",
    ],
    image: "/images/sections/servicesShowcase/sml-training-2.webp",
    imagePosition: "80% center",
    href: "/services/training",
  },
];

export function getRelatedServices(currentHref, limit = 3) {
  return services
    .filter((service) => service.href !== currentHref)
    .slice(0, limit);
}
